import { defineStore } from "pinia";
import { proprietairesService } from "@/api/services/esupplyvet/proprietairesService";

export const useProprietairesStore = defineStore("proprietaires", {
  state: () => ({
    proprietaires: [],
    loading: false,
    error: null,
  }),

  getters: {
    /**
     * Retourne les propriétaires actifs (non supprimés)
     */
    activeProprietaires: state => {
      return state.proprietaires.filter(p => !p.isDeleted);
    },

    /**
     * Retourne les propriétaires formatés pour l'affichage dans un select
     */
    formattedProprietaires: state => {
      return state.proprietaires
        .filter(p => !p.isDeleted)
        .map(p => ({
          id: p.id,
          fullName: `${p.firstName} ${p.lastName}`,
          email: p.email,
          firstName: p.firstName,
          lastName: p.lastName,
          phoneNumber: p.phoneNumber,
        }))
        .sort((a, b) => a.fullName.localeCompare(b.fullName));
    },
  },

  actions: {
    /**
     * Récupère la liste des propriétaires depuis l'API
     */
    async fetchProprietaires() {
      this.loading = true;
      this.error = null;

      try {
        const data = await proprietairesService.getProprietaires();
        this.proprietaires = data;
      } catch (error) {
        this.error = "Erreur lors de la récupération des propriétaires";
        console.error("Erreur fetchProprietaires:", error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Ajoute un nouveau propriétaire
     * @param {Object} proprietaireData - Les données du propriétaire à créer
     * @param {string} proprietaireData.firstName - Prénom du propriétaire
     * @param {string} proprietaireData.lastName - Nom du propriétaire
     * @param {string} proprietaireData.email - Email du propriétaire
     * @param {string} proprietaireData.phoneNumber - Numéro de téléphone du propriétaire
     * @returns {Promise} Promesse contenant les données du nouveau propriétaire
     */
    async addProprietaire(proprietaireData) {
      this.loading = true;
      this.error = null;

      try {
        const newProprietaire = await proprietairesService.createProprietaire(proprietaireData);
        // Recharger la liste après ajout
        await this.fetchProprietaires();
        return newProprietaire;
      } catch (error) {
        this.error = "Erreur lors de l'ajout du propriétaire";
        console.error("Erreur addProprietaire:", error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Remet à zéro les états d'erreur et de chargement
     */
    resetState() {
      this.loading = false;
      this.error = null;
    },
  },
});
